module.exports = __webpack_public_path__ + "static/img/qyfljc-ywlc.931eb1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qyfljc-ywlc.png
// module id = pgMw
// module chunks = 0